<template>
  <div class="indexAdminLogin_LoginInput_class_div_img">
    <img src="@/assets/indexLogin_Code.png" alt="" @click="gotoPhone">
  </div>
  <div class="indexAdminLogin_LoginInput_class_div_top">

      <el-image
        v-if="systemMetaBaseData.systemLogo !==null"
        :src="systemMetaBaseData.systemLogo.systemFileUrl"
        fit="fill"
    />


    <div class="indexAdminLogin_LoginInput_class_title">
      欢迎使用{{ systemMetaBaseData.systemName }}
    </div>
  </div>
  <div class="indexAdminLogin_qRCode_class_input">
    <div class="indexAdminLogin_LoginInput_class_div_top_image_x">
      <el-image :src="
                formCodeImgData.verifyCodeImg
            " fit="fill"/>
       <div @click="RefreshClick()" v-if="formCodeImgData.errorShow" class="image_err">
        <el-icon color="#111111" size="28"><Refresh /></el-icon>
        <span>二维码已失效，点击刷新</span>
       </div>
    </div>
  </div>
</template>

<script setup>
import {onMounted, reactive, ref, onBeforeUnmount, defineEmits} from 'vue';
import {requestNoToken} from '@/util/adminRequest.js';
import store from '@/configure/store';
import {validate} from '@/util/validate';
import router from '@/configure/router';
import {ElMessage} from 'element-plus'
// 返回上级调用参数
const emits = defineEmits(['childMethod'])
//系统基础数据
const systemMetaBaseData = store.state.systemMetaBaseData;
// 初始值
const formData = reactive({
  adminUserPhone: '', // 手机号
  adminUserPhoneCode: '', // 手机号验证码
});
// 二维码数据
const formCodeImgData = reactive({
  errorShow:false,
  verifyKey: '', // 二维码id
  verifyCodeImg: '', // 二维码base64
  min: 1, // 定时器初始值
  max: 10, // 定时器条件值
  timer: null //定时器名称
});
// 发送短信数据
const smsSendData = reactive({
  smsSendState: false, // 短信发送状态
  smsSendTime: 0, // 短信发送倒计时
  timer: null, // 定时器
});
//跳转到扫码登录
const gotoPhone = function () {
  emits('childMethod', 'accountLogin', "")
}

// 开启定时器
const setTimer = () => {
  formCodeImgData.timer = setInterval(function () {
    //定时器开始
    formCodeImgData.min++;
    getVerifyStatus()
    console.log(formCodeImgData.min);
    // 定时器关闭
    // if (formCodeImgData.min == formCodeImgData.max) {
    //     clearInterval(formCodeImgData.timer); // 满足条件时 停止计时
    // }
  }, 1000); // 时间
};

// 校验二维码状态
const getVerifyStatus = () => {
  requestNoToken({
    url: '/Api/userSystem/LesseeMainModule/LesseeMainUserLogin/VerifyEnterpriseQRCodeLogin',
    data: {
      qRCodeID: formCodeImgData.verifyKey,
    },
  }).then((res) => {
    if (res.data.codeType == 1) {
         store.commit('saveUserData',
          {
            lesseeManageToken: res.data.data.lesseeManageToken,
            lesseeManageData: res.data.data.lesseeManageData,
            authorityData: res.data.data.authorityData,
          });
          emits('childMethod', 'selectLessee', "")
    } else {
      switch (res.data.codeType) {
        case 3:

          formCodeImgData.errorShow = true
          clearInterval(formCodeImgData.timer)
          break;
        case 4:

          formCodeImgData.errorShow = true
          clearInterval(formCodeImgData.timer)
          break;
        default:
          break;
      }
    }


  });
}
const RefreshClick = () =>{
  setTimer()
  getCodeImg()
}
// 获取二维码
const getCodeImg = () => {
  requestNoToken({
    url: '/Api/userSystem/LesseeMainModule/LesseeMainUserLogin/GetQRCode',
    data: {},
  }).then((res) => {
    formCodeImgData.verifyKey = res.data.verifyKey;
    formCodeImgData.verifyCodeImg = res.data.verifyCodeImg;
    formCodeImgData.errorShow  = false
  });
};
// 表单ref
const formDataRef = ref(null);

// 校验
const rules = reactive({
  adminUserPhone: [
    {required: true, message: '请输入手机号', trigger: 'blur'},
    {
      pattern: validate.phone,
      message: '手机号格式不正确',
      trigger: 'blur',
    },
  ],
  adminUserPhoneCode: [
    {required: true, message: '请输入验证码', trigger: 'blur'},
  ],
});

// 发送短信验证码
const sendLoginSMSCode = function () {
  if (validate.phone.test(formData.adminUserPhone) == false) {
    return;
  }
  requestNoToken({
    url: '/Api/baseSystem/AdminModule/AdminUserLogin/SendLoginSMSCode',
    data: {
      adminUserPhone: formData.adminUserPhone,
    },
  }).then((res) => {
    setSMSSendNum();
  });
};

// 短信验证码数字
const setSMSSendNum = function () {
  // 验证手机号
  const TIME_COUNT = 60;
  if (!smsSendData.timer) {
    smsSendData.smsSendTime = TIME_COUNT;
    smsSendData.smsSendState = true;
    smsSendData.timer = setInterval(() => {
      if (
          smsSendData.smsSendTime > 0 &&
          smsSendData.smsSendTime <= TIME_COUNT
      ) {
        smsSendData.smsSendTime--;
      } else {
        smsSendData.smsSendState = false;
        clearInterval(smsSendData.timer); // 清除定时器
        smsSendData.timer = null;
      }
    }, 1000);
  }
};

// 管理员用户手机号登录
const sMSLogin = function () {
  formDataRef.value.validate((valid) => {
    if (valid) {
      requestNoToken({
        url: '/Api/baseSystem/AdminModule/AdminUserLogin/SMSLogin',
        data: {
          adminUserPhone: formData.adminUserPhone,
          adminUserPhoneCode: formData.adminUserPhoneCode,
        },
      }).then((res) => {
        store.commit('saveUserData', {
          lesseeManageToken: res.data.lesseeManageToken,
          lesseeManageData: res.data.lesseeManageData,
          authorityData: res.data.authorityData,
        });
        router.push('/workbench');
      });
    }
  });
};

// 启动调用
onMounted(() => {
  setTimer();
  getCodeImg();
});
// 消失调用
onBeforeUnmount(() => {
  clearInterval(formCodeImgData.timer); // 清除定时器
})
</script>
<style scoped>

.indexAdminLogin_LoginInput_class_button {
  background: #2b43ff;
  border-radius: 2px;
  height: 40px;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

/deep/ .el-checkbox__input.is-checked .el-checkbox__inner {
  background: #2b43ff;
  border-color: #2b43ff;
}

/deep/ .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #2b43ff;
}
</style>
